import React from "react";
import Header from "./Header";
import PqrsdReports from "../pqrsd/PqrsdReports";

export default function LayoutPqrsdReports() {
  return (
    <>
      <Header />
      <PqrsdReports />
    </>
  );
}
